import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { EditorModule } from '@progress/kendo-angular-editor';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { ImageCropperModule } from 'ngx-image-cropper';
import { EventDetailsComponent } from './events/details/event-details.component';
import { ExhibitDesignerComponent } from './exhibits/exhibit-designer/exhibit-designer.component';
import { ViewInstructorComponent } from './instructors/view-instructor.component';
import { MyLiveEventsComponent } from './my-account/my-live-events/my-live-events.component';
import { ScheduleEventComponent } from './my-account/my-live-events/schedule-event/schedule-event.component';
import { MyPostersComponent } from './my-account/posters/my-posters.component';
import { CallForPostersComponent } from './posters/call-for-posters/call-for-posters.component';
import { IsAuthenticatedGuard } from './_guards/isAuthenticated.gaurd';
import { ApplicationPipesModule } from './_shared/modules/application-pipes.module';
import { ConferencePageComponent } from './conferences/page/conference-page.component';

import { GroupRegistrationComponent } from './conferences/registration/group-registration.component';
import { SharedAccountConferenceModule } from './shared-account-conference.module';
import { CallForPapersComponent } from './conferences/papers/call-for-papers.component';
import { AddPersonModalComponent } from './conferences/papers/add-person-modal.component';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import  {  PdfViewerModule  }  from  'ng2-pdf-viewer';
import { CallForSponsorsComponent } from './conferences/sponsors/call-for-sponsors.component';
import { OnSiteCheckinComponent } from './conferences/check-in/on-site-checkin.component';
import { CheckinPreviewModalComponent } from './conferences/check-in/checkin-preview-modal.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { BoothPickerComponent } from './conferences/sponsors/booth-picker.component';
import { ViewCartComponent } from './conferences/sponsors/view-cart.component';
import { CheckoutComponent } from './conferences/sponsors/checkout.component';
import { OrderCompleteComponent } from './conferences/sponsors/order-complete.component';
import { ViewProductComponent } from './conferences/sponsors/view-product.component';
import { FinalUserApprovalComponent } from './conferences/papers/final-user-approval.component';
import { SubmissionApprovalEditorComponent } from './organization/admin/conferences/abstract-management/approval-editor/submission-approval-editor.component';
import { SharedOrgAdminConferenceCMSModule } from './shared-orgadmin-conferencecms.module';
import { ConferenceLayoutComponent } from './conferences/conference-layout.component';
import { PublicPaperReviewComponent } from './organization/admin/conferences/abstract-management/public-review/public-paper-review.component';
import { AbstractManagementSubmissionsComponent } from './organization/admin/conferences/abstract-management/submissions/abstract-management-submissions.component';
import { ConferenceScheduleElementComponent } from './conferences/page/elements/conference-schedule/conference-schedule-element.component';
import { ConferenceProgramExportComponent } from './conferences/page/elements/program-export/conference-program-export.component'
import { ComboBoxModule, DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { OrganizationEventListingComponent } from './conferences/page/elements/organization-event-listing/organization-event-listing.component';
import { SponsorProductListingComponent } from './conferences/page/elements/sponsor-product-listing/sponsor-product-listing.component';
import { PaginatorModule } from 'primeng/paginator';
import { SkeletonModule } from 'primeng/skeleton';
import { ModifyRegistrationModalComponent } from './conferences/registration/modify-registration-modal.component';
import { CourseDetailsComponent } from './courses/course-details.component';
import { EventDetailsFlyoutComponent } from './conferences/page/elements/conference-schedule/event-details-flyout.component';
import { ConferencePdfViewerComponent } from './conferences/page/elements/conference-pdf-viewer/conference-pdf-viewer.component';
import { ConferenceLandingPageComponent } from './sponsorship-portal/landing-page/conference-landing-page.component';
import { ViewLandingPageComponent } from './conferences/landing-pages/view-landing-page.component';

import { NgxMaskModule, IConfig } from 'ngx-mask'
import { ReservationsComponent } from './conferences/reservations.component';
import { SurveyModule } from 'survey-angular-ui';
import { ViewSurveyComponent } from './conferences/surveys/view-survey.component';
import { SharedCMSModule } from './shared-cms-module';
import { PackagePurchaseModalComponent } from './conferences/registration/package-purchase-modal.component';
import { ConferenceRegistrationComponent } from './conferences/registration/conference-registration.component';
import { MemberLookupModalComponent } from './conferences/registration/member-lookup-modal.component';
import { RegistrationConfirmationComponent } from './conferences/registration/registration-confirmation.component';
import { ModifyRegistrationComponent } from './conferences/registration/modify-registration.component';
import { EventPickerControl } from './_controls/event-picker.control';
import { TooltipModule } from 'primeng/tooltip';
import { PublicGuestRoomComponent } from "./conferences/GuestRooms/public-guest-room.component";
import { GroupRegistrationRegistrantModalComponent } from './conferences/registration/group-registration-registrant-modal.component';
import { RegistrationHelperService } from './_services/registration-helper.service';
import { ConferenceGroupDiscountsModalComponent } from './conferences/registration/conference-group-discounts-modal.component';
import { ModifyPurchaseAtCheckinComponent } from "./conferences/check-in/modify-purchase-at-checkin/modify-purchase-at-checkin.component";
import { ZXingScannerModule } from "@zxing/ngx-scanner";
import { ScannerComponent } from "./conferences/scanner/scanner.component";


@NgModule({
  declarations: [
    GroupRegistrationComponent,
    ConferencePageComponent,
    CallForPapersComponent,
    CallForSponsorsComponent,
    ViewCartComponent,
    AddPersonModalComponent,
    BoothPickerComponent,
    CheckoutComponent,
    ConferenceRegistrationComponent,
    ModifyRegistrationComponent,
    OrderCompleteComponent,
    ViewProductComponent,
    PackagePurchaseModalComponent,
    FinalUserApprovalComponent,
    ConferenceLayoutComponent,
    PublicPaperReviewComponent,
    OnSiteCheckinComponent,
    CheckinPreviewModalComponent,
    ModifyRegistrationModalComponent,
    EventDetailsFlyoutComponent,
    ViewLandingPageComponent,
    ReservationsComponent,
    ViewSurveyComponent,
    MemberLookupModalComponent,
    RegistrationConfirmationComponent,
    EventPickerControl,
    PublicGuestRoomComponent,
    GroupRegistrationRegistrantModalComponent,
    ConferenceGroupDiscountsModalComponent,
    ModifyPurchaseAtCheckinComponent,
    ScannerComponent
  ],
  entryComponents: [
    AddPersonModalComponent,
    CheckinPreviewModalComponent,
    ModifyRegistrationModalComponent,
    EventDetailsFlyoutComponent
  ],
  imports: [
    NgbModalModule,
    InputsModule,
    SkeletonModule,
    TooltipModule,
    ComboBoxModule,
    NgxMaskModule.forRoot(),
    SurveyModule,
    ZXingScannerModule,
    EditorModule,
    PaginatorModule,
    SharedCMSModule,
    ImageCropperModule,
    PdfViewerModule,
    DragDropModule,
    DropDownsModule,
    DateInputsModule,
    SharedOrgAdminConferenceCMSModule,
    SharedAccountConferenceModule,
    ApplicationPipesModule.forRoot(),
    RouterModule.forChild([
      { path: 'scanner', component: ScannerComponent, data: { reviewMode:true}},
      { path: 'call-for-papers/submissions/review/:submissionId', component: SubmissionApprovalEditorComponent, data: { reviewMode:true}},
      { path: 'on-site-checkin', component: OnSiteCheckinComponent},
      { path: 'on-site-checkin/modify', component: ModifyPurchaseAtCheckinComponent},
      { path: 'on-site-checkin/preview', component: CheckinPreviewModalComponent},
      { path: 'survey-embed/:surveyId', component: ViewSurveyComponent},
      { path: 'page-embed/:page', component: ConferencePageComponent},
      { path: 'page-embed/:page/modify', component: ModifyRegistrationComponent},
      { path: 'page-embed/:page/confirmation', component: RegistrationConfirmationComponent},
      { path: 'call-for-papers/submissions/reviews', component: PublicPaperReviewComponent, children:[
        { path: '', redirectTo: 'my-papers', pathMatch: 'full' },
        { path: 'my-papers', component: AbstractManagementSubmissionsComponent, data: { reviewMode:true, myPapers:true } },
        { path: 'all-papers', component: AbstractManagementSubmissionsComponent, data: { reviewMode:true, myPapers:false } },
      ]},

      { path: '', component: ConferenceLayoutComponent, children:[
        { path: '', redirectTo: 'home', pathMatch: 'full' },
        { path: 'registration/group', component: GroupRegistrationComponent },
        { path: 'registration/group/edit/:linkUniqueId', component: GroupRegistrationComponent },
        { path: 'registration/modify', component: ModifyRegistrationComponent },
        { path: 'registration/confirmation', component: RegistrationConfirmationComponent },
        { path: 'registration/:packageId', component: ConferenceRegistrationComponent },
        { path: 'call-for-papers', component: CallForPapersComponent },
        { path: 'my-breakouts', component: ReservationsComponent },
        { path: 'sponsors/landing-pages/:pageId', component: ViewLandingPageComponent },
        { path: 'call-for-papers/:paperId/user-approval', component: FinalUserApprovalComponent },
        //{ path: 'call-for-sponsors', component: CallForSponsorsComponent },
        { path: 'call-for-sponsors/:productId', component: ViewProductComponent },
        { path: 'cart', component: ViewCartComponent },
        { path: 'checkout', component: CheckoutComponent },
        { path: 'order-complete', component: OrderCompleteComponent },
        { path: 'events/:id', component: EventDetailsComponent, data: { isConference: true}},
        { path: 'courses/:id', component: CourseDetailsComponent, data: { isConference: true}},
        { path: 'my-exhibits', redirectTo: '/account/exhibits' },
        { path: 'my-exhibits/:id/designer', component: ExhibitDesignerComponent, canActivate: [IsAuthenticatedGuard] },
        { path: 'my-posters', component: MyPostersComponent, canActivate: [IsAuthenticatedGuard], data:{title:"My Posters"} },
        { path: 'my-posters/:id/edit', component: CallForPostersComponent, canActivate: [IsAuthenticatedGuard], data:{title:"Add/Edit Poster"}},
        { path: 'my-events', component: MyLiveEventsComponent, canActivate: [IsAuthenticatedGuard], data:{title:'My Live events'} },
        { path: 'my-events/:id/edit', component: ScheduleEventComponent, data:{title:'Schedule Event'}},
        { path: 'call-for-posters', component: CallForPostersComponent, data:{title:'Call for posters'} },
        { path: 'instructors/:id', component: ViewInstructorComponent  },
        { path: 'survey/:surveyId', component: ViewSurveyComponent   },
        { path: 'hotel-reservations/:userId', component: PublicGuestRoomComponent   },
        { path: ':page', component: ConferencePageComponent },
    ] },
    ])
  ],
    providers: [
      RegistrationHelperService
    ]
})
export class ConferenceCMSModule{}
